module.exports = __webpack_public_path__ + "static/media/usa-flag.f9cfcac4.png";